export const Filters = {
    isActive: 'isActive',
};

export const enum MaxFileSizeBytes {
    WhiteList = 30_000 // 30Kb
};

export const enum MerchantGroupName {
    ECommerce = 'eCommerce',
};
